import UISelect from 'UIComponents/input/UISelect';
import FilterInfoWarnings from '../common/FilterInfoWarnings';
import ConditionBox from '../common/ConditionBox';
import ConditionError from '../common/ConditionError';
import EditorConditionActionsContainer from './EditorConditionActionsContainer';
import EditorUIFieldSet from './EditorUIFieldSet';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'UICo... Remove this comment to see the full error message
import UITypeaheadResultsItem from 'UIComponents/typeahead/results/UITypeaheadResultsItem';
import EditorConditionAsset from './EditorConditionAsset';
import { useAssetMembershipCondition } from '../../hooks/useAssetMembershipCondition';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditorAssetMembershipCondition = props => {
  const {
    condition,
    conditionPath,
    dataSeleniumInfo,
    filterFamily
  } = props;
  const {
    fieldLabel,
    onConditionDelete,
    onSelectedOptionChange,
    operatorOptions
  } = useAssetMembershipCondition(filterFamily, condition, conditionPath);
  return /*#__PURE__*/_jsx(EditorConditionActionsContainer, {
    condition: condition,
    conditionPath: conditionPath,
    dataSeleniumInfo: dataSeleniumInfo,
    filterFamily: filterFamily,
    onConditionDelete: () => onConditionDelete(conditionPath),
    children: /*#__PURE__*/_jsx(ConditionBox, {
      children: /*#__PURE__*/_jsxs(EditorUIFieldSet, {
        legend: fieldLabel,
        children: [/*#__PURE__*/_jsx(View, {
          marginBlockEnd: "200",
          as: "div",
          children: /*#__PURE__*/_jsx(EditorConditionAsset, {
            condition: condition,
            filterFamily: filterFamily
          })
        }), /*#__PURE__*/_jsx(UISelect, {
          "data-selenium-info": dataSeleniumInfo,
          "data-selenium-test": "fr-filter-operator-select"
          //@ts-expect-error `userHasNoAccess` does not exist on `DSFieldRecordInstance`
          ,
          disabled: condition.field && condition.field.userHasNoAccess,
          onSelectedOptionChange: onSelectedOptionChange,
          optionRenderer: option => /*#__PURE__*/_jsx(UITypeaheadResultsItem, {
            message: true,
            option: option
          }),
          options: operatorOptions,
          value: condition.constructor.toString()
        }), /*#__PURE__*/_jsx(ConditionError, {
          condition: condition
        }), /*#__PURE__*/_jsx(FilterInfoWarnings, {
          condition: condition
        })]
      })
    })
  });
};
export default EditorAssetMembershipCondition;